/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file BuyLicenseBtn.tsx
 * @desc Created on Thu May 15 2025 20:56:31
 * @copyright All rights reserved @ Inarix
 */
import { Button } from "@mui/material";
import { Mail } from "@mui/icons-material";
import { SALES_EMAIL } from "../../config";
import { useTranslation } from "react-i18next";

export function BuyLicenseBtn() {
  const [t] = useTranslation("global");
  return (
    <div className="button-buy-licenses">
      <Button
        sx={{ textTransform: "none" }}
        variant="contained"
        onClick={(e) => {
          window.location.href = `mailto:${SALES_EMAIL}`;
          e.preventDefault();
        }}
        endIcon={<Mail />}
      >
        {t("licenses.buyMore")}
      </Button>
    </div>
  );
}
